import { ActionTypes } from '../actions/cardProjectActionsV2';

const initialState = {
  hasRecipientAddressing: false,
};

const cardCustomizationBar = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_RECIPIENT_ADDRESSING_OPTION: {
      return { ...state, hasRecipientAddressing: action.payload };
    }
    default:
      return state;
  }
};

export default cardCustomizationBar;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/cardCustomizationBar.js
 **/